import React, { useEffect, useMemo } from 'react';
import './ListToast.css';

const TOAST_DURATION_MS = 1800;
const VIEWPORT_PADDING = 12;

const getAnchoredStyle = (anchor) => {
  const centerX = anchor.left + anchor.width / 2;
  const spaceAbove = anchor.top - VIEWPORT_PADDING;
  const showAbove = spaceAbove >= 44;

  const left = Math.min(
    Math.max(centerX, VIEWPORT_PADDING),
    window.innerWidth - VIEWPORT_PADDING
  );

  if (showAbove) {
    return {
      top: anchor.top - 8,
      left,
      transform: 'translate(-50%, -100%)',
      placement: 'above',
    };
  }

  return {
    top: anchor.bottom + 8,
    left,
    transform: 'translate(-50%, 0)',
    placement: 'below',
  };
};

const ListToast = ({ visible, onClose, onViewList, anchor = null, message }) => {
  useEffect(() => {
    if (!visible) return undefined;
    const timer = setTimeout(onClose, TOAST_DURATION_MS);
    return () => clearTimeout(timer);
  }, [visible, onClose, anchor]);

  const style = useMemo(() => {
    if (!anchor) return null;
    return getAnchoredStyle(anchor);
  }, [anchor]);

  if (!visible) return null;

  const isAnchored = Boolean(anchor && style);
  const placement = style?.placement;
  const toastMessage =
    message || (isAnchored ? 'Saved!' : 'Added to Saved Deals');

  return (
    <div
      className={`list-toast${isAnchored ? ' list-toast--anchored' : ' list-toast--center'}${
        placement ? ` list-toast--${placement}` : ''
      }`}
      style={
        isAnchored
          ? { top: style.top, left: style.left, transform: style.transform }
          : undefined
      }
      role="status"
      aria-live="polite"
    >
      <span className="list-toast-message">{toastMessage}</span>
      {onViewList && !message?.includes('full') && (
        <button type="button" className="list-toast-action" onClick={onViewList}>
          View
        </button>
      )}
    </div>
  );
};

export default ListToast;
